import { createFileRoute, Link } from '@tanstack/react-router';
import { ClientOnboardingForm } from '../components/forms/ClientOnboardingForm.js';
import { requireRole } from '../lib/auth-guard.js';

export const Route = createFileRoute('/client/onboarding')({
  component: ClientOnboardingPage,
  beforeLoad: async ({ context }) => {
    await requireRole(context.queryClient, ['client']);
  },
});

function ClientOnboardingPage() {
  return (
    <div className="min-h-screen p-6 max-w-3xl mx-auto space-y-6">
      <Link to="/client" className="text-sm text-[var(--muted-foreground)] hover:text-foreground">
        ← Zurück zur Übersicht
      </Link>
      <ClientOnboardingForm />
    </div>
  );
}
